import { Inject } from '@resourceful-hono/core';
import { BaseResource } from '../BaseResource.ts';
import { OAuthService } from '../../../services/OAuth/index.ts';
import { WebAuthnService } from '../../../services/WebAuthnService.ts';

export default abstract class AuthResource extends BaseResource {
  @Inject()
  declare protected readonly oAuth: OAuthService;
  @Inject()
  declare protected readonly webAuthn: WebAuthnService;
}